<template>
  <div class="alert-danger-simple">
    <slot />
  </div>
</template>
